import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";

import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";

import CircularProgress from "@material-ui/core/CircularProgress";
import * as actionCreators from "../../Action/Tenant/AddDocuments";
import Images from "../../Assets/Images";

import "../../Styles/ProjectDocuments.scss";

import * as moment from "moment";

class AddDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      filesList: "",
      selectedFile: null,
      showUpload: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onKeyPressChange = (e) => {
    if (this.state.showUpload) {
      this.setState({
        showUpload: !this.state.showUpload,
        filesList: null,
      });
    }
  };

  onChangeHandler = (e) => {
    const { actions } = this.props;
    const file = e.target.files;
    let consolidateFile = [];
    let largeFiles = [];

    if (e.target.files.length > 0) {
      for (let i = 0; i < e.target.files.length; i++) {
        let fileType = this.checkMimeType(e.target.files[i]);
        if (fileType) {
          let temp = this.validateSize(e.target.files[i]);
          if (temp) {
            consolidateFile.push(e.target.files[i]);
          } else {
            largeFiles.push(e.target.files[i]);
          }
        } else {
          let err = e.target.files[i].type + " file type unable to upload \n";
          toastr.error(err);
          return;
        }
      }
    } else {
      toastr.error("No Files Selected");
      return;
    }

    if (largeFiles.length > 0) {
      let err = "";
      for (let i = 0; i < largeFiles.length; i++) {
        let position = i + 1; // Use i + 1 instead of i++ to avoid incrementing i
        err =
          "Position " +
          position +
          " Located " +
          largeFiles[i].name +
          " is too large, please pick a smaller file\n";
        toastr.error(err);
      }
      consolidateFile.pop();
      largeFiles.pop();
      return;
    } else {
      this.setState({
        filesList: consolidateFile,
        showUpload: !this.state.showUpload,
      });
    }
  };

  checkMimeType = (file) => {
    // list allow mime type
    const types = ["image/png", "image/jpeg", "image/gif"];
    // compare file type find doesn't matach
    if (types.every((type) => file.type !== type)) {
      return false;
    }
    return true;
  };

  validateSize = (file) => {
    let size = 30000;
    if (file.size > size) {
      return false;
    } else {
      return true;
    }
  };

  fileUploadHandler = (event) => {
    event.preventDefault();

    const { actions } = this.props;
    //let formData = new FormData();
    var formData = new FormData();

    let files = [];
    // for(let x = 0; x<this.state.filesList.length; x++) {
    //    files.push('file', this.state.filesList[x])
    // }

    console.log("======files=====");
    formData.append("files", files);
    //formData.append('document', 'project');
    formData.append("ProjectId", 1);
    console.log("------beforee send:::----" + formData);
    actions.AddDocument(formData);
  };

  // drag and drop

  getUploadParams = () => {
    return { url: "https://httpbin.org/post" };
  };

  handleChangeStatus = async ({ meta, file }, status) => {
    if (status === "done") {
      let blnCheck = await this.compareList(this.state.filesList, meta);
      if (blnCheck) {
        this.setState((prevState) => ({
          filesList: [...prevState.filesList, meta],
        }));
      } else if (blnCheck === undefined) {
        this.setState((prevState) => ({
          filesList: [...prevState.filesList, meta],
        }));
      } else {
        toastr.error("File already exist");
        return;
      }
    }
  };

  compareList = (previousList, currentMeta) => {
    const arrFiles = Array.from(previousList);

    if (arrFiles.length > 0) {
      for (let i = 0; i < arrFiles.length; i++) {
        if (
          arrFiles[i].name === currentMeta.name &&
          arrFiles[i].size === currentMeta.size &&
          arrFiles[i].type === currentMeta.type
        ) {
          return false;
        }
      }
    } else {
      return true;
    }
  };

  handleSubmit = (files, allFiles) => {
    const { actions } = this.props;

    let localFiles = [];
    const arrFiles = Array.from(files);

    if (this.state.filesList.length !== arrFiles.length) {
      allFiles.forEach((f) => {
        f.remove();
      });
      this.setState({ filesList: "" });
      return;
    } else {
      for (let i = 0; i < arrFiles.length; i++) {
        let formData = new FormData();
        formData.append("files", arrFiles[i].file);

        formData.append("Id", this.props.id);

        const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
        formData.append("CreatedDate", CreatedDate);
        formData.append("CreatedBy", secureLocalStorage.getItem("userName"));
        formData.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
        formData.append("DocType", this.props.type);
        localFiles.push(formData);
      }
      //formData.append('files', arrFiles[0].file);
      //formData.append('ProjectId', 1);
      // formData.append('TenantKey', secureLocalStorage.getItem("tenantKey"));

      allFiles.forEach((f) => f.remove());
      this.setState({ filesList: "" });
      actions.commonDocumentUpload(localFiles);
    }
  };

  cancelUploadDocument = () => {
     // For all other cases or if history is not available, use browser's native back functionality
      // This ensures back functionality works in any browser
      if (this.props.history) {
        this.props.history.goBack();
      } else {
        window.history.back();
      }
  };

  handleFileSelection = (event) => {
    this.setState({
      selectedFile: event.target.files,
    });
  };
  render() {
    const { loader } = this.props;
    const { showUpload } = this.state;

    return (
      <div className="upload">
        <div className="card">
          {/* Back Button */}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
            <button
              onClick={this.cancelUploadDocument}
              style={{
                display: 'flex',
                alignItems: 'center',
                background: 'transparent',
                border: 'none',
                color: '#FFFFFF',
                cursor: 'pointer',
                padding: '5px',
                fontSize: '14px'
              }}
            >
              <img src={Images.BACK} alt="Back" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
              Back
            </button>
          </div>

          {/* Spinner */}
          {loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}

          {/* <p>Upload documents to this project</p> */}
          {/* <ReactDropzone accept="image/*" onDrop={this.handleDrop}>Drop an image, get a preview! </ReactDropzone> */}
          <div className="ddCont">
            <h5>Upload Documents</h5>
            <div className="dragAndDrop">
              <Dropzone
                //getUploadParams={this.getUploadParams}
                onChangeStatus={this.handleChangeStatus}
                onSubmit={this.handleSubmit}
                //accept="image/*,audio/*,video/*"
                //minSizeBytes = {1024}
                //maxSizeBytes = {30720}
                //validate={this.handleValidation}
                submitButtonDisabled={(files) => files.length < 0}
                styles={{ dropzone: { minHeight: 300, maxHeight: 300 } }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    loader: state.AddDocuments.loaderStatus,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddDocuments);
